

























































































import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { EscalatedAlert, EventType } from '@/api';
import { VatService } from '@/pages/account/products/milk/vats/service/vat-service';
import Toast from '@/components/display/toast.vue';
import TooltipButton from '@/components/elements/buttons/tooltip-button.vue';
import StatusChangeModal from './status-change-modal.vue';

@Component({
	components: {
		TooltipButton,
		StatusChangeModal,
	},
})

export default class EscalatedAlertCard extends Vue {
	@Prop({ type: Object })
	public alert!: EscalatedAlert;

	// Temperature arrow props

	@Prop({ type: Number })
	public currentTemp?: number | null;

	@Prop({ type: Boolean, default: false })
	public isTempGoingUp?: boolean;

	@Prop({ type: Number, default: false })
	public latestLogTemp?: number | null;

	@Prop({ type: Boolean, default: false })
	public tempIsAvailable?: boolean;

	// Modal props

	@Prop({ type: Object })
	public event?: EventType | null;

	@Prop({ type: Number })
	public saveVolume?: number | null;

	public newStatus: string | null = null;
	public currentStatus: string | null = null;

	private readonly toast = new Toast();
	public readonly vatService: VatService = new VatService();

	public get alertStatus(): string {
		return this.alert?.status ?? '';
	}

	public get isHCP() {
		return this.event ? this.event.isSpecial : false;
	}

	public showMilkScoreCloseModal() {
		this.$bvModal.show('confirm-milk-score');
	}

	public hideMilkScoreCloseModal() {
		this.$bvModal.hide('confirm-milk-score');
	}

	@Emit('update')
	public emitUpdate() {}

	public handleStatusButtonClick(buttonStatus: string) {
		if (this.alert) {
			this.currentStatus = this.alertStatus;
			this.newStatus = buttonStatus;
			this.$root.$emit('bv::show::modal', 'status-change');
		}
	}

	public async handleMilkScoreClose(): Promise<void> {
		if(this.alert?.entity_id != null) {
			const response = await this.vatService.closeMilkScore(this.alert.entity_id);
			if (response.errorMessage) {
				this.toast.makeToast(response.errorMessage, 'Close Milk Score Error', 'danger');
			} else {
				this.toast.makeToast('Milk Score Closed', 'Success', 'success');
			}
		} else {
			this.toast.makeToast('Error', 'Entity not found to close milk score', 'danger', false);
		}
	}

	public mounted() {
		if (this.alert) {
			this.currentStatus = this.alertStatus;
			this.newStatus = this.alertStatus;
		}
	}
}
